import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import ReactLoading from 'react-loading';
import * as S from './styles';

import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import ProfileCardMenu from '../../organisms/ProfileCardMenu';
import TabsContainer from '../../molecules/TabsContainer';
import UserDataTab from '../../organisms/UserDataTab';

function UserDatas() {
  const userData = useSelector((state) => state.auth.user_data);

  return (
    <S.Container>
      {useSelector((state) => state.auth.user_logged_in) < 1 ? <Redirect to="/entrar" /> : null}

      <Header />
      <NavBar />
      <MainContent>
        <S.UserDataContainer>
          <ProfileCardMenu />
          <TabsContainer
            icon_code="far fa-user"
            title="MEUS DADOS"
            tabs={[{ title: ' ', url: '/usuario/vitrine' }]}>
            {!userData ? (
              <div style={{ alignSelf: 'center', margin: '50px' }}>
                <ReactLoading type="spinningBubbles" color="#002666" height={60} width={59} />
              </div>
            ) : null}
            <UserDataTab data={userData} />
          </TabsContainer>
        </S.UserDataContainer>
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default UserDatas;
